<!-- Services -->
<section id="services">
    <!-- Section Content -->
    <div class="box-grey">
        <div class="wrapper">
            <div class="row margin-none col-half">
                <div class="col-md-5 col-sm-12 half padding-all">
                    <!-- <p><img src="assets/img/works-1-big.png" alt="Services" class="img-full"></p> -->
                    <h1 class="title-big letter-spacing line-bottom left">ठेवीवरील व्याजाचे प्रचलित दर.</h1>
                    <ul class="nav navbar-nav list-inline">
                        <li class="list-inline-item padding-all-10"><b>1.</b> बँकेत रिकरिंग ठेव, पिम्मी ठेव, मुदत ठेव, योजना राबविल्या जातात.</li>
                        <li class="list-inline-item padding-all-10"><b>2.</b> जेष्ठ नागरिक ( वय ६०पूर्ण ),  ठेवीदारास नियमित व्याजदरापेक्षा <b>अर्धा टक्का</b> अधिक व्याज देण्यात येते. </li>
                        <!-- सहकारी संस्था तसेच रु. १५ लाख व त्यापेक्षा जाडा रक्कम एकमुस्त गुंतविणाऱ्या -->
                        <li class="list-inline-item padding-all-10"><b>3.</b> बँकेला डिपॉझिट इंशुरन्स स्कीम लागू असल्याने सर्व ठेवी सुरक्षित आहे. </li>
                        <li class="list-inline-item padding-all-10"><b>4.</b> सुवर्ण तारणांवर लवकर व सुभरित्या कर्जाची सोय उपलब्ध आहे.</li>
                        <li class="list-inline-item padding-all-10"><b>5.</b> बँकेच्या मुख्य शाखा महाल व नंदनवन शाखा येथे <b>लॉकर्स उपलब्ध </b>आहेत.
                            <ul class="nav navbar-nav list-inline padding-all-10">
                                <li><b>लॉकर भाडे खालील प्रमाणे -</b></li>
                                <li>लहान - ११००.००</li>
                                <li>मध्यम - १८००.००</li>
                                <li>मोठा - २५००.००</li>
                            </ul>
                        </li>

                        <li class="list-inline-item padding-all-10"><b>6.</b> बँकेत खातेदारांकरिता <b>RTGS / NEFT व डिमांड ड्रॅफ्ट,</b><b> Any Branch Banking सुविधा उपलब्ध.</b></li>
                        <li class="list-inline-item padding-all-10"><b>7.</b> जेष्ठ नागरिक ०.५०% अतिरिक्त व्याज दर फक्त मुदत ठेव करिता.</li>
                        <li class="list-inline-item padding-all-10"><b>8.</b> वयाचा ५८ व्या वर्षी सेवानिवृत्त होणाऱ्या म.न.पा. व बँक कर्मचाऱ्याकरिता विशेष ठेव योजना २ ते ३ वर्षाकरिता ७.५०% व्याज दर. <b>(कमीत कमी ठेव ५ लक्षाच्या वरील रकमेवर).</b> </li>
                    </ul>
                    <div class="space "></div>
                    <p><a routerLink="/contact " class="btn btn-dark letter-spacing ">संपर्क</a></p>
                </div>
                <div class="col-md-7 col-sm-12 half padding-all box-white ">
                    <div class="grid-list ">
                        <div class="row margin-none ">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">क्र.</th>
                                        <th scope="col">ठेव खाते प्रकार</th>
                                        <th scope="col">व्याजदर द. सा. द. शे.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">1</th>
                                        <td>बचत ठेव खाते</td>
                                        <td>२.७५%</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">2</th>
                                        <td>नियमित मासिक बचत खाते (१-७-२०१५ पासून)</td>
                                        <td>६.०%</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">3</th>
                                        <td colspan="2"><b>टाईम ठेव खाते  दि. ०१-०६-२०१७ पासून लागू</b></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">अ.</th>
                                        <td>१५ दिवस ते ६० दिवस </td>
                                        <td>५.००%</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">ब.</th>
                                        <td>६१ दिवस ते ९० दिवस</td>
                                        <td>५.५०%</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">क.</th>
                                        <td>९१ दिवस ते ३६४ दिवस </td>
                                        <td>६.००%</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">4</th>
                                        <td colspan="2"><b>मुदत ठेव खाते</b></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">अ.</th>
                                        <td>१ ते ३ वर्ष</td>
                                        <td>७.००% </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">ब.</th>
                                        <td>३ वर्षाचे वर ते ५ वर्षा पर्यंत</td>
                                        <td>७.२५%</td>
                                    </tr>
                                    <!-- <tr>
                                        <th scope="row">5</th>
                                        <td colspan="2"><b>विशेष मुदत ठेव</b></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">अ.</th>
                                        <td>५५५ दिवसांकरिता</td>
                                        <td>८% </td>
                                    </tr> 
                                    <tr> 
                                        <td></td>  
                                        <td colspan="2">फक्त वय ६० वर्षा  वरील ग्राहकांकरिता</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">6</th>
                                        <td colspan="2"><b>आवर्ती ठेव</b></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">अ.</th>
                                        <td>१५ महिन्याकरिता </td>
                                        <td>८%</td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Section Content End -->
</section>
<!-- Services End -->